import { Api } from '@/services/Api'

export default {
  isStringRatedPowerConfigured(plantId) {
    return Api().get(`/api/v2/scb/is-string-rated-power-configured/${plantId}`)
  },
  fetchScbTableData(param) {
    return Api().post('/api/v2/scb/table', param)
  },
  fetchScbGraphData(param) {
    return Api().post('/api/v2/scb/graph', param)
  }
}